import { render } from "./MoneyValue.vue?vue&type=template&id=27cdd771"
import script from "./MoneyValue.vue?vue&type=script&lang=js"
export * from "./MoneyValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__